import { Section } from '../../styles/InstitutionalViewStyles';
import { ValuesGrid } from '../styles/ValuesStyles';
import ValueCard from './ValueCard';

const Values = () => {
  const values = [
    {
      value: 'Amor',
      description:
        'El amor es compasión y empoderamiento. Somos movidos a compasión por las necesidades de los demás, pero al mismo tiempo empoderamos a otros para que también sean instrumentos de compasión en el mundo.',
      image: 'https://comunidadmde.s3.us-east-1.amazonaws.com/intranet/valores/amor.png',
    },
    {
      value: 'Excelencia',
      description:
        'Excelencia es hacer todo como si fuera para Dios, con esfuerzo y disciplina. "La excelencia honra a Dios e inspira a la gente".',
      image: 'https://comunidadmde.s3.us-east-1.amazonaws.com/intranet/valores/excelencia.png',
    },
    {
      value: 'Presencia',
      description:
        'Presencia significa ser conscientes de que Dios está con nosotros en todo momento. Nuestro deseo es honrar Su Presencia en cada aspecto de nuestras vidas: en cómo nos comportamos, cómo hablamos y en todo lo que hacemos.',
      image: 'https://comunidadmde.s3.us-east-1.amazonaws.com/intranet/valores/presencia.png',
    },
    {
      value: 'Amabilidad',
      description:
        'La amabilidad es el buen trato a los demás, es la sonrisa. Cuando hacemos las cosas con excelencia y añadimos amabilidad, el impacto en las personas será mayor.',
      image: 'https://comunidadmde.s3.us-east-1.amazonaws.com/intranet/valores/amabilidad.png',
    },
  ];

  return (
    <Section>
      <h3>
        <i className="fa-solid fa-heart"></i>
        Nuestros Valores
      </h3>
      <ValuesGrid>
        {values.map((val, index) => (
          <ValueCard
            key={val.value}
            value={val.value}
            description={val.description}
            image={val.image}
            index={index}
          />
        ))}
      </ValuesGrid>
    </Section>
  );
};

export default Values;
